import OccupacyDetailsItem from "./OccupacyDetailsItem";
export default OccupacyDetailsItem